// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__vSDSR","title":"styles_title__SaJNX","plane":"styles_plane__4_4lR","back":"styles_back__yvHHv"};